import { render, staticRenderFns } from "./UnpaidLeave.vue?vue&type=template&id=696f08be&"
import script from "./UnpaidLeave.vue?vue&type=script&lang=js&"
export * from "./UnpaidLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports